<template>
  <div class="itemlist">
    <v-card>
      <v-card-title>
        <!-- img src="../../../static/images/icon8icons/icons8-paint-palette-50.png" / -->
        <h1>Naloxone Location Information</h1>
        <v-spacer/>
      </v-card-title>

      <v-form model="valid" ref="form">
          <v-layout row>
              <v-text-field class="pa-1"
                          v-model="newLocation.id"
                          :rules="nameRules"
                          label="Location ID"
                          required
               ></v-text-field>
              <span>
                  Last updated: {{ formattedDate }}
              </span>
          </v-layout>
          <v-text-field
                      class="pa-1"
                      v-model="newLocation.name"
                      :rules="nameRules"
                      label="Location name"
                      required
           ></v-text-field>

           <v-layout row>
               <v-text-field
                           class="pa-1"
                           v-model="newLocation.person"
                           :rules="nameRules"
                           label="Contact person"
                           required
                ></v-text-field>
                <v-text-field
                            prepend-icon="phone"
                            class="pa-1"
                            v-model="newLocation.phone"
                            :rules="validPhone"
                            label="Phone of contact at location"
                            required
                            mask=phone
                 ></v-text-field>
           </v-layout>

             <v-layout>
                 <v-checkbox
                    v-model="newLocation.medicinePresent"
                    :label="`Medicine present: ${newLocation.medicinePresent.toString()}`"
                 ></v-checkbox>
                 <v-flex>
                      <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="formattedExpirationDate"
                                  label="Expiration date"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="pickedExpirationDate" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                 </v-flex>
             </v-layout>

             <hr />
             <v-card elevation="0">
                     <v-card-text>
                         Availability: When is naloxone available?
                         <DayHours v-for="(item, index) in [0,1,2,3,4,5,6]" :key="item"
                            :index="index"
                            :updateNum="updateNum"
                            @change="(val) => dayHourChange(index, val)"
                            v-bind:day="newLocation['days'][index]"
                            v-bind:timeRange="newLocation['timeRanges'][index]">
                        </DayHours>


                     </v-card-text>

             </v-card>
             <hr />


             <v-textarea
                         v-model="newLocation.description"
                         :rules="nameRules"
                         label="Description"
                         required
                         solo
              ></v-textarea>
              <v-layout row>
                  <v-text-field
                              class="pa-1"
                              v-model="address"
                              label="Lookup street address (e.g. 123 Main Street, Fairfax VA 22033)"
                   ></v-text-field>
                   <v-btn :loading="geocoderLoading" @click="geocodeAddr">
                        Lookup
                        <v-icon>
                          map
                        </v-icon>
                    </v-btn>
              </v-layout>
              <v-layout row>
                  <v-slider class="pa-1"
                            step="15"
                            @input="radiusUpdated"
                            v-bind:value="radius"
                            min=150
                            max=3218.69
                            :label="radiusLabel"></v-slider>
              </v-layout>
              <v-layout row>
                  <v-text-field
                              class="pa-1"
                              v-model="newLocation.lat"
                              :rules="validLat"
                              label="Latitude"
                              required
                   ></v-text-field>
                   <v-text-field
                               class="pa-1"
                               v-model="newLocation.lng"
                               :rules="validLng"
                               label="Longitude"
                               required
                    ></v-text-field>
                    <v-btn :loading="getCurrentLocationLoading" @click="getCurrentLocation">
                        Get Current Location <v-icon>
                          gps_fixed
                        </v-icon>
                    </v-btn>
              </v-layout>

              <MapView :circleRadius="radius" :center="{'lat' : newLocation.lat, 'lng':newLocation.lng}" :edittable="true" @moved="mapMoved"></MapView>
              <br />
              <v-layout row>
                  <v-spacer></v-spacer>
                  <div v-if="edit">
                      <v-btn @click="cancel">Cancel Changes</v-btn>
                      <v-btn :loading="saveInProgress" @click="saveChanges(true)" class="success">Save Changes</v-btn>
                  </div>
                  <div v-else>
                      <v-btn @click="cancel">Cancel</v-btn>
                      <v-btn :loading="saveInProgress" @click="saveChanges(false)" class="success">Add Location</v-btn>
                  </div>
              </v-layout>

      </v-form>


      <div class="error--text" v-if="errMessage != null">
        <v-layout row>
            <v-spacer></v-spacer>{{errMessage}}
        </v-layout>
      </div>

    </v-card>
      <hr />

</div>

</template>

<script>
import {mapState} from 'vuex'

import utils from '../utils.js'
import config from '../config.js'

import MapView from '../components/MapView.vue'
import DayHours from '@/components/DayHours.vue'

import {gmapApi} from 'vue2-google-maps'

//import ReturnToDashboard from './ReturnToDashboard'

export default {
  name: 'AddEditLocation',
  components: {
      MapView, DayHours
  },
  data () {
    return {
        address: "",
        radius: 3218, // Meters
        getCurrentLocationLoading: false,
        geocoderLoading: false,
        saveInProgress: false,
        valid: false,
        edit: false,
        menu2: false,
        updateNum: 1,
        newLocation: {
            id: null,
            name: null,
            lastUpdate: 0,
            person: null,
            phone: null,
            medicinePresent: false,
            description: null,
            lat: 0,
            lng: 0,
            timeRanges:[
                [0,1440], // All minutes of the day
                [0,1440], // All minutes of the day
                [0,1440], // All minutes of the day
                [0,1440], // All minutes of the day
                [0,1440], // All minutes of the day
                [0,1440], // All minutes of the day
                [0,1440], // All minutes of the day
            ],
            days: [true, true, true, true, true, true, true],
            expirationDate: new Date(),
            radius: 3218, // Meters
        },
        pickedExpirationDate: null,
      loading: false,
      errMessage: null,
      nameRules: [
          v => !!v || 'This is required'
      ],
      validPhone: [
          utils.phoneValidation("Phone number must be 10 digits")
      ],
      validLat: [
          v => v >= -90 && v <= 90 || 'Latitude must be between -90 and 90 decimal degrees'
      ],
      validLng: [
          v => v >= -180 && v <= 180 || 'Longitude must be between -180 and 180 decimal degrees'
      ],
    }
  },
  computed: {
    ...mapState({
      locations: state => state.locations.locations,
      activeLocation: state => state.locations.activeLocation
    }),
    radiusLabel: function () {
        // Convert to feet
        if (this.radius > 1000) {
            let miles = (this.radius / 1609.344).toFixed(2)
            return `Radius to show naloxone in NaloxoFind ${miles} miles`
        } else {
            let yards = Math.floor(this.radius * 1.09361)
            return `Radius to show naloxone in NaloxoFind ${yards} yards`
        }


    },
    google: gmapApi,
    formattedDate: function () {
        return this.formatDate(this.newLocation.lastUpdate)
    },

    startTime: function () {
        // Convert from minutes to time
        return utils.minutesToTime(this.newLocation.timeRange[0])
    },
    endTime: function () {
        // Convert from minutes to time
        return utils.minutesToTime(this.newLocation.timeRange[1])
    },
    formattedExpirationDate: function () {
        if (this.newLocation.expirationDate) {
            return new Date(this.newLocation.expirationDate).toISOString().substr(0, 10)
        } else {
            return "No Date"
        }
    }
  },
  watch: {
      pickedExpirationDate: function (nw) {
          // Convert to a real date
          let d = Date.parse(nw)
          console.log("NEW D is:"+d)

          // Set newLocation.expirationDate
          this.newLocation.expirationDate = (new Date(d)).getTime()
      }
  },
  mounted: function () {
      const orig = this.activeLocation
      if (orig && orig !== null) {
          this.newLocation.firebaseId = orig.firebaseId
          this.newLocation.id = orig.id
          this.newLocation.name = orig.name
          this.newLocation.lastUpdate = orig.lastUpdate
          this.newLocation.person = orig.person
          this.newLocation.phone = orig.phone
          this.newLocation.medicinePresent = orig.medicinePresent
          this.newLocation.description = orig.description
          this.newLocation.lat = orig.lat
          this.newLocation.lng = orig.lng
          this.newLocation.group = orig.group
          this.newLocation.days = orig.days.slice()
          this.newLocation.timeRanges = orig.timeRanges
          this.newLocation.expirationDate = orig.expirationDate
          this.radius = orig.radius
          this.edit = true
      } else {
          let now = (new Date()).getTime()
          const year = 365 * 24 * 60 * 60 * 1000
          this.newLocation.expirationDate  = now+year

          this.edit = false
      }

  },
  methods: {
    radiusUpdated: function (val) {
       this.radius = val
    },
    geocodeAddr: function() {
          let request =  {
           address: this.address,
           //bounds: LatLngBounds,
           //componentRestrictions: GeocoderComponentRestrictions,
           region: "US"
          }

          let geocoder = new this.google.maps.Geocoder()
          geocoder.geocode(request, (results, status) => {
            if (status == 'OK') {
              let position = results[0].geometry.location;
              // console.log("Found location: "+position)
              this.newLocation.lat = position.lat()
              this.newLocation.lng = position.lng()

              // Set the address that was found
              this.address = results[0].formatted_address
              this.geocoderLoading = false


            } else {
              console.error('Geocode was not successful for the following reason: ' + status);
              alert('Sorry, we could not find that location. ' + status);
            }
          });
      },

    dayHourChange: function(index, newVal) {
        // console.log("Index "+index+"   CHANGED newVal:"+JSON.stringify(newVal))
        let day
        if (newVal['dayCheck']) {
            day = true
        } else {
            day = false
        }
        this.newLocation['days'][index] = day // newVal['dayCheck']
        this.newLocation['timeRanges'][index] = newVal['timeRange']
        this.updateNum += 1 // Force redraw
    },
    getCurrentLocation: function () {
        this.getCurrentLocationLoading = true
        const options = {
            enableHighAccuracy: true, //defaults to false
            timeout: Infinity, //defaults to Infinity
            maximumAge: 30 //defaults to 0
        }
        // Get the user's current location
        this.$getLocation(options)
        .then(coordinates => {
            this.newLocation.lat = coordinates['lat']
            this.newLocation.lng = coordinates['lng']
            this.getCurrentLocationLoading = false
        });

    },
    mapMoved: function(position) {
      this.newLocation.lat = position.lat()
      this.newLocation.lng = position.lng()
    },
    formatDate: function (d) {
        return utils.formatDateFromMilliseconds(d)
    },
    editLocation: function (location) {
      this.$router.push({name: 'addeditlocation', params: location})
    },
    cancel: function () {
        // console.log("Go back1... "+this.$router.mode)
        // console.log("HISTORY: "+JSON.stringify(window.history));
        this.$router.go(-1)
    },
    saveChanges: async function (update) {

        this.errMessage = ""
        let isValid = this.$refs.form.validate()
        if (!isValid) {
            this.errMessage = "Fix the form errors and try again."
            return
        }

        // Save updates
        this.saveInProgress = true
        try {
          this.newLocation.lng = parseFloat(this.newLocation.lng)
          this.newLocation.lat = parseFloat(this.newLocation.lat)
          this.newLocation.radius = this.radius

          // Now link them and charge the account
          var saveLocation = config.getFunctions().httpsCallable('addUpdateLocation')
          const rc = await saveLocation(
            {
              location: this.newLocation,
              update: update
            }
          )
          console.log("saveLocation return: "+JSON.stringify(rc.data))
          this.saveInProgress = false

          // Go back to previous page
          // console.log("saveLocation setActiveLocation: "+JSON.stringify(rc.data))
          this.$store.commit('locations/setActiveLocation', this.newLocation)
          // console.log("saveLocation routerBack: "+JSON.stringify(rc.data))
          // this.$router.go(-1) -- FAILS IN SAFARI!
          this.$router.push({"name":"LocManager"})


          // Go to the edit page (?)
          // console.log("saveLocation exit: "+JSON.stringify(rc.data))
        } catch (err) {
          console.error('ERROR saveLocation: ' + err.message)
          this.errMessage = "ERROR: "+err.message
          this.saveInProgress = false
        }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.itemlist {
  width: 100%;
}

</style>
